<template>
    <div class="headerBox">
        <div class="content">
            <div><span>总运单：{{ orderAllTotalNums }}</span></div>
            <div><span>待调度运单：{{ orderWaitTotalNums }}</span></div>
            <div><span>已调度运单:{{ orderWaitTotalNumsed }}</span></div>
            <div>|</div>
            <div><span>已选点数：{{totalPoints}}</span></div>
            <div><span>订单数：{{taskTotalNO}}</span></div>
            <div><span>件数：{{taskTotalCount}}</span></div>
            <div><span>重量：{{taskTotalWeight}} kg</span></div>
            <div><span>体积：{{taskTotalVolume}} m³</span></div>
            <div><span>货值：{{taskTotalOrderValue}} 元</span></div>
            <div><span>包装数：{{taskTotalPackageQuantity}}</span></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        allOrderNums: {
            type: Array,
            default () {
                return [];
            }
        },
        orderTotalNums: {
            type: Array,
            default () {
                return [];
            }
        },
        allselectedPoints: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    computed: {
        // 总运单数
        orderAllTotalNums: function () {
            return this.orderTotalNums.length;
        },
        // 待调度订单
        orderWaitTotalNums: function () {
            return this.orderTotalNums.filter(v => v.taskStatus === 0).length;
        },
        // 已调度订单
        orderWaitTotalNumsed: function () {
            return this.orderTotalNums.filter(v => v.taskStatus !== 0).length;
        },
        totalPoints: function () {
            return this.allselectedPoints.length;
        },
        taskTotalQty: function () {
            return this.allOrderNums.length;
        },
        taskTotalNO: function () {
            return this.allOrderNums.map(v => v.customerOrderNo).length;
        },
        taskTotalVolume: function () {
            return this.allOrderNums.reduce((partical, value) => {
                const taskTotalVolume = partical + (value.totalVolume || 0);
                return Math.round(taskTotalVolume * 1000000) / 1000000;
            }, 0);
        },
        taskTotalWeight: function () {
            return this.allOrderNums.reduce((partical, value) => {
                const taskTotalWeight = partical + (value.totalGrossWeight || 0);
                return Math.round(taskTotalWeight * 1000) / 1000;
            }, 0);
        },
        taskTotalCount: function () {
            return this.allOrderNums.reduce((partical, value) => {
                const taskTotalCount = partical + (value.totalQty || 0);
                return Math.round(taskTotalCount * 1000) / 1000;
            }, 0);
        },
        taskTotalOrderValue: function () {
            return this.allOrderNums.reduce((partical, value) => {
                const taskTotalOrderValue = partical + (value.orderValue || 0);
                return Math.round(taskTotalOrderValue * 1000) / 1000;
            }, 0);
        },
        //包装数
        taskTotalPackageQuantity: function () {
            return this.allOrderNums.reduce((partical, value) => {
                const taskTotalPackageQuantity = partical + (value.totalPackageQuantity || 0);
                return Math.round(taskTotalPackageQuantity * 100) / 100;
            }, 0);
        },
    }
};
</script>

<style lang="less">
.headerBox {
    background-color: white;
    padding: 5px 10px;
    display: flex;
    font-size: 10px;
    color: #555757;
    align-items: center;

    .content {
        display: flex;

        & div {
            padding-right: 6px;
            font-size: 12px;
        }
    }
}
</style>
